import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { postData } from "../../services/Services";
import CustomModal from "../atomic/Modal/CustomModal";
import { css } from "@emotion/react";
import styles from "./SendMethod.module.css";
import { useDispatch, useSelector } from "react-redux";
import { chevronRightLogo, smsLogo, whatsappLogo } from "../../assets";
import { phoneNumberLoginOtp } from "../../helper/otpPhoneHelper";
import { setSendMethod } from "../../redux/action/otpAction";
import { OTP_DATA } from "../../constant/otpData";
import { saveUser } from "../../redux/action/userAction";

const SendMethod = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const request_id = searchParams.get("request_id");
  const redirect_uri = searchParams.get("redirect_uri");
  const resource_id = searchParams.get("resource_id");
  const isRegister = searchParams.get("isRegister");
  const cancel_uri = searchParams.get("cancel");
  const twofa_type = searchParams.get("2fa_type");

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");

  // Redux State
  const dispatch = useDispatch();
  const verifiedPhone = useSelector((state) => state.otpData.phone);

  const handleSendBySMS = async (e) => {
    e.preventDefault();
    handleVerificationPhoneNumber(OTP_DATA.OTP_SEND_SMS);
  };

  const handleSendByWhatsapp = async (e) => {
    e.preventDefault();
    handleVerificationPhoneNumber(OTP_DATA.OTP_SEND_WHATSAPP);
  };

  const handleVerificationPhoneNumber = async (method) => {
    setLoading(true);
    const body = {
      phone: method === OTP_DATA.OTP_SEND_SMS ? verifiedPhone : "",
      wa: method === OTP_DATA.OTP_SEND_WHATSAPP ? verifiedPhone : "",
      requestID: request_id,
      redirectURI: redirect_uri,
      resourceID: resource_id,
      "2fa_type": twofa_type ? twofa_type : "",
    };
    postData("/v3/auth/login/pwa/phonenumber", token, body)
      .then((response) => {
        if (response.data.status === 1) {
          const {
            userModel,
            resourceActivation,
            authorization_code,
            is2FAType,
            requestID,
            clientID,
          } = response.data.data;
          dispatch(setSendMethod(method));
          if (resourceActivation) {
            navigate(
              `/verify-otp?token=${token}&request_id=${requestID}&redirect_uri=${redirect_uri}&resource_id=${resource_id}&isRegister=${isRegister}&cancel=${cancel_uri}&authorization_code=${authorization_code}&2fa_type=${
                is2FAType ? is2FAType : ""
              }&client_id=${clientID}&isLastPage=true`
            );
          } else {
            dispatch(saveUser(userModel));
            navigate(
              `/add-resource?token=${token}&request_id=${requestID}&redirect_uri=${redirect_uri}&resource_id=${resource_id}&isRegister=${isRegister}&cancel=${cancel_uri}&authorization_code=${authorization_code}&2fa_type=${
                is2FAType ? is2FAType : ""
              }&client_id=${clientID}&isLastPage=true`
            );
          }
        } else if (response?.data?.status === 1000037) {
          setOpen(true);
          setMessage(response?.data?.note);
          setTitle("Gagal");
        } else if (response?.data?.status === 1000046) {
          setOpen(true);
          setMessage(response?.data?.data);
          setTitle("Gagal");
        } else {
          setOpen(true);
          setMessage("Terjadi kesalahan, silahkan coba lagi");
          setTitle("Gagal");
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setOpen(true);
        setMessage(
          error?.response?.data?.description
            ? error.response.data.description
            : "Terjadi kesalahan, silahkan coba lagi"
        );
        setTitle("Gagal");
      });
  };

  return (
    <div className={styles.loginContainer}>
      {loading && (
        <Box
          position={"absolute"}
          width="100vw"
          top="0"
          left="0"
          height="100vh"
          zIndex="9999999999"
          display="flex"
          alignItems="center"
          justifyContent={"center"}
        >
          <Box
            position={"absolute"}
            width="100vw"
            top="0"
            left="0"
            sx={{ background: "black", opacity: "10%" }}
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent={"center"}
          ></Box>
          <PuffLoader css={css} color={"black"} loading={loading} size={150} />
        </Box>
      )}
      <Box width="80%" sx={{ height: "100vh" }}>
        {!verifiedPhone && <div>Akses Tidak Diijinkan</div>}
        {verifiedPhone && (
          <Box height={"100%"}>
            <div
              style={{
                width: "100%",
                height: "100%",
                paddingBlock: "20px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Typography fontWeight={600} fontSize={22} textAlign={"start"}>
                Pilih Metode Verifikasi
              </Typography>
              <Typography
                fontWeight={500}
                fontSize={14}
                textAlign={"justify"}
                color={"#818181"}
              >
                Pilih salah satu metode di bawah ini untuk mendapatkan kode
                verifikasi
              </Typography>
              <br />

              <Box
                display={"flex"}
                gap={2}
                padding={1}
                sx={{
                  backgroundColor: "white",
                  "&:hover": {
                    backgroundColor: "#A6A6A630", // Change background color on hover
                    cursor: "pointer",
                  },
                  transition: "background-color 0.3s", // Optional: smooth transition
                }}
                onClick={handleSendBySMS}
              >
                <Box>
                  <img src={smsLogo} alt="sms_logo" />
                </Box>
                <Typography fontWeight={400} fontSize={14} textAlign={"start"}>
                  {`Melalui `}
                  <span style={{ fontWeight: 600 }}>SMS</span>
                  {` ke ${phoneNumberLoginOtp(verifiedPhone)}`}
                </Typography>
                <Box textAlign={"end"} flexGrow={1}>
                  <img src={chevronRightLogo} />
                </Box>
              </Box>
              <br />

              <Box
                display={"flex"}
                gap={2}
                padding={1}
                sx={{
                  backgroundColor: "white",
                  "&:hover": {
                    backgroundColor: "#A6A6A630", // Change background color on hover
                    cursor: "pointer",
                  },
                  transition: "background-color 0.3s", // Optional: smooth transition
                }}
                onClick={handleSendByWhatsapp}
              >
                <Box>
                  <img src={whatsappLogo} alt="wa_logo" />
                </Box>
                <Typography fontWeight={400} fontSize={14} textAlign={"start"}>
                  {`Melalui `}
                  <span style={{ fontWeight: 600 }}>Whatsapp</span>
                  {` ke ${phoneNumberLoginOtp(verifiedPhone)}`}
                </Typography>
                <Box textAlign={"end"} flexGrow={1}>
                  <img src={chevronRightLogo} />
                </Box>
              </Box>
            </div>
          </Box>
        )}

        <CustomModal
          open={open}
          onClose={() => setOpen(false)}
          variant={"error"}
          text={message}
          title={title}
        />
      </Box>
    </div>
  );
};

export default SendMethod;
